import React, { useEffect, useRef, useState } from "react";
import { BoldBI } from "@boldbi/boldbi-embedded-sdk";
import { DELIVERABLE_URL } from "config";
import axios from "axios";

const UserAnalyticsDashboard = () => {
  const dashboard = useRef(null);
  const userEmail = import.meta.env.VITE_BOLD_BI_USER_EMAIL;
  const dashboardId = import.meta.env.VITE_BOLD_BI_DASHBOARD_ID;
  const [authToken, setAuthToken] = useState(null);

  useEffect(() => {
    if (!dashboardId) return;

    const tokenKey = `boldbi_token_${dashboardId}`;
    const storedToken = sessionStorage.getItem(tokenKey);
    let industryNames = [];

    let userCompetencyIndustry = localStorage.getItem("userCompetencyIndustry") !== "null" ? localStorage.getItem("userCompetencyIndustry") : null;

    if (userCompetencyIndustry) {
      userCompetencyIndustry = JSON.parse(userCompetencyIndustry);
      industryNames = userCompetencyIndustry.map((item) => item.industryName).filter(Boolean);
    }

    const filter = `[{&user_industry=IN(${industryNames.join(",")})}]`;

    getAuthToken();

    async function getAuthToken() {
      try {
        const response = await axios.post(`${DELIVERABLE_URL}/deliverable/bi-token`, {
          userEmail,
          dashboardId,
          // filter
        });

        const result = response.data?.data;
        if (result?.success && result?.token) {
          sessionStorage.setItem(tokenKey, result.token);
          setAuthToken(result.token);
        }
      } catch (error) {
        console.error("Error fetching BoldBI token:", error);
      }
    }
  }, [dashboardId, userEmail]);

  useEffect(() => {
    if (!authToken) return;

    const config = {
      serverUrl: import.meta.env.VITE_BOLD_BI_EMBED_SERVER_URL,
      siteIdentifier: "site/platformanalytics",
      embedContainerId: "dashboard",
      embedType: "component",
      environment: "onpremise",
      width: "100%",
      height: "100%",
    };
    const { embedContainerId, embedType, environment, width, height, serverUrl, siteIdentifier } = config;

    dashboard.current = BoldBI.create({
      serverUrl: `${serverUrl}${siteIdentifier}`,
      dashboardId: dashboardId,
      embedContainerId,
      embedType,
      environment,
      width,
      height,
      token: authToken,
      dashboardSettings: {
        showHeader: true,
        showExport: false,
        showRefresh: false,
        themeSettings: {
          dashboard: "platform_dashboard_theme_v2", // Specify the name under which you saved the dashboard theme file in Bold BI server.
        },
        expirationTime: 86400,
      },
    });

    dashboard.current.loadDashboard();

    return () => {
      const container = document.getElementById("dashboard");
      if (container) container.innerHTML = "";
    };
  }, [authToken, dashboardId]);

  return (
    <div className="w-full" style={{ height: "calc(100vh - 80px)" }}>
      <div id="dashboard" className="w-full h-full"></div>
    </div>
  );
};

export default UserAnalyticsDashboard;
